import axios, { AxiosInstance, AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { tryHideFullScreenLoading } from "@/components/Loading";
import { ElMessage } from "element-plus";
import { checkStatus } from "./checkStatus";
import { AxiosCanceler } from "./axiosCancel";
import router from "@/routers";
import { clearAllStorage, getCookie, removeCookie } from '@/utils'
// getToken
// export interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
//     loading?: boolean;
//     cancel?: boolean;
//     headers?: any
// }

// Determine if we're running in packaged Electron (file:// protocol)
const isPackagedElectron = window.location.protocol === 'file:';

const config = {
    // Set baseURL when in packaged Electron app
    baseURL: isPackagedElectron ? 'http://124.222.181.112:8000' : undefined,
    // 设置超时时间
    timeout: 30000,
    // timeout: 3 * 60 * 1000,
    // 跨域时候允许携带凭证
    withCredentials: true
};

const axiosCanceler = new AxiosCanceler();

class RequestHttp {
    service: AxiosInstance;
    public constructor(config: AxiosRequestConfig) {
        // instantiation
        this.service = axios.create(config);

        /**
         * @description 请求拦截器
         * 客户端发送请求 -> [请求拦截器] -> 服务器
         * token校验(JWT) : 接受服务器返回的 token,存储到 vuex/pinia/本地储存当中
         */

        // console.log('getCookie(RequestHttp)=====>', getCookie('Authorization'))
        this.service.interceptors.request.use(
            (config: any) => {
                // 重复请求不需要取消，在 api 服务中通过指定的第三个参数: { cancel: false } 来控制
                config.cancel ??= true;
                config.cancel && axiosCanceler.addPending(config);
                // 当前请求不需要显示 loading，在 api 服务中通过指定的第三个参数: { loading: false } 来控制
                config.headers['Authorization'] = getCookie('Authorization')
                return config;
            },
            (error: AxiosError) => {
                return Promise.reject(error);
            }
        );

        /**
         * @description 响应拦截器
         *  服务器换返回信息 -> [拦截统一处理] -> 客户端JS获取到信息
         */
        this.service.interceptors.response.use(
            (response: AxiosResponse & { config: any }) => {
                const { data, config } = response;

                axiosCanceler.removePending(config);
                config.loading && tryHideFullScreenLoading();
                // 登录失效


                // 全局错误信息拦截（防止下载文件的时候返回数据流，没有 code 直接报错）
                // if (data.code && data.code !== ResultEnum.SUCCESS) {
                //     ElMessage.error(data.msg);
                //     return Promise.reject(data);
                // }
                // 成功请求（在页面上除非特殊情况，否则不用处理失败逻辑）
                return data;
            },
            async (error: AxiosError) => {
                const { response } = error;
                tryHideFullScreenLoading();
                // 请求超时 && 网络错误单独判断，没有 response
                if (error.message.indexOf("timeout") !== -1) ElMessage.error("请求超时！请您稍后重试");
                if (error.message.indexOf("Network Error") !== -1) ElMessage.error("网络错误！请您稍后重试");
                // 根据服务器响应的错误状态码，做不同的处理
                if (response) checkStatus(response.status);
                if (response?.status === 401) {
                    router.replace('/');
                    clearAllStorage();
                    removeCookie("Authorization");
                    removeCookie("refreshToken");
                }
                // 服务器结果都没有返回(可能服务器错误可能客户端断网)，断网处理:可以跳转到断网页面
                if (!window.navigator.onLine) router.replace("/500");
                return Promise.reject(error);
            }
        );
    }

    /**
     * @description 常用请求方法封装
     */
    get(url: string, params?: object, _object = {}): Promise<any> {
        return this.service.get(url, { params, ..._object });
    }
    post(url: string, params?: object | string, _object = {}): Promise<any> {
        return this.service.post(url, params, _object);
    }
    put(url: string, params?: object, _object = {}): Promise<any> {
        return this.service.put(url, params, _object);
    }
    delete(url: string, data?: any, _object = {}): Promise<any> {
        return this.service.delete(url, { data, ..._object });
    }
    download(url: string, params?: object, _object = {}): Promise<BlobPart> {
        return this.service.post(url, params, { ..._object, responseType: "blob" });
    }
}

export default new RequestHttp(config);
